export default "__VITE_ASSET__VHoW_SBD__"